<script setup lang="ts">
import { CIcon } from '@coreui/icons-vue'
import { cilLockLocked } from '@coreui/icons'
const eventStore = useEventStore()
const props = defineProps({
  to: {
    type: String,
    default: '#'
  },
  permission: {},
  active: {
    default: false
  }
})
</script>

<template>
  <li class="nav-item">
    <router-link
      :class="{ 'nav-link': true, active: props.active }"
      :to="props.to"
      v-if="!permission || eventStore.hasApp(permission)"
    >
      <slot></slot>
    </router-link>
    <span :class="{ 'nav-link': true, active: props.active }" v-else>
      <CIcon :icon="cilLockLocked" customClassName="nav-icon" />
      <slot></slot>
    </span>
  </li>
</template>
